import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/dispensacao`

    return {
        create(id, filaId) {
            return filaId ? repository.get(`${baseUrl}/create/${id}/${filaId}`) : repository.get(`${baseUrl}/create/${id}`);
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        historicoReceitas(id, params) {

            return repository.get(`${baseUrl}/historico-receitas/${id}`, params)
        },
        printReceitaDispensada(id) {

            return repository.get(`${baseUrl}/receita-dispensada/${id}`)
        },
        printReceitaHistorico(id) {
            return repository.get(`${baseUrl}/receita-historico/${id}`)
        },
        getUltimaRetirada(params) {

            return repository.get(`${baseUrl}/ultima-retirada`, params)
        },
        getSupervisor(queryParms) {

            return repository.get(`${baseUrl}/supervisor?${urlUtil.serialize(queryParms)}`)
        },
        getMedicamentosAVencer(queryParms) {

            return repository.get(`${baseUrl}/medicamento-a-vencer?${urlUtil.serialize(queryParms)}`)
        },
        getItensSolicitacaoMedicamento(prescricaoId) {

            return repository.get(`${baseUrl}/solicitacao-medicamento-item/${prescricaoId}`)
        },
    }
}